import { UiTourType } from '@booking-booster-client/models';
import { settingsAdvertisersDetail } from './steps';

export const SettingsAdvertisersDetailTour: UiTourType = {
  slug: 'settings-advertisers-detail',
  steps: settingsAdvertisersDetail,
  nextStep: 'settings/advertisements/paramethers',
  viewingRequired: true,
};
